/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_CtaInputs */

const en_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Account`)
};

const de_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

const fr_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un compte`)
};

const es_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta`)
};

const it_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea account`)
};

const nl_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account aanmaken`)
};

const pl_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

const fi_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tili`)
};

const da_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret konto`)
};

const sv_auth_signup_cta = /** @type {(inputs: Auth_Signup_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa konto`)
};

/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Auth_Signup_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_signup_cta = /** @type {((inputs?: Auth_Signup_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_signup_cta(inputs)
	if (locale === "fr") return fr_auth_signup_cta(inputs)
	if (locale === "es") return es_auth_signup_cta(inputs)
	if (locale === "it") return it_auth_signup_cta(inputs)
	if (locale === "nl") return nl_auth_signup_cta(inputs)
	if (locale === "pl") return pl_auth_signup_cta(inputs)
	if (locale === "fi") return fi_auth_signup_cta(inputs)
	if (locale === "da") return da_auth_signup_cta(inputs)
	if (locale === "sv") return sv_auth_signup_cta(inputs)
	return en_auth_signup_cta(inputs)
});